namespace RioERP.Carts {
    export interface FranchiseeProductCategoryForm {
        ProductId: Serenity.IntegerEditor;
        CategoryId: Serenity.IntegerEditor;
        IsActive: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
    }

    export class FranchiseeProductCategoryForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.FranchiseeProductCategory';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseeProductCategoryForm.init)  {
                FranchiseeProductCategoryForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DateEditor;

                Q.initFormType(FranchiseeProductCategoryForm, [
                    'ProductId', w0,
                    'CategoryId', w0,
                    'IsActive', w1,
                    'InsertUserId', w0,
                    'InsertDate', w2,
                    'UpdateUserId', w0,
                    'UpdateDate', w2
                ]);
            }
        }
    }
}
